import React, { useRef } from 'react';
import AppliedJobCard from './AppliedJobCard';
import { Link } from 'react-router-dom';
import Loading from '../Loading/Loading';
import useFetchEmployeeApplications from '../../../hooks/employee/useFetchEmployeeApplications';
import RecommendedJobsDetail from '../../Jobs/JobDetail/RecommendedJobsDetail/RecommendedJobsDetail';
import './applications.css';

const Applications = () => {
  const { jobPosts: applications, isLoading, error } = useFetchEmployeeApplications();
  const recommendedJobsRef = useRef(null);

  const scrollToRecommendedJobs = () => {
    if (recommendedJobsRef.current) {
      recommendedJobsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="applications__profile-container">
      <div className="applications__title-container">
        <h1>Postulaciones</h1>
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
          {applications.length === 0 && (
            <Link to="/trabajos">
              <button className="profile-view__button">Ver trabajos</button>
            </Link>
          )}
          <button className="profile-view__button" onClick={scrollToRecommendedJobs}>
            Ver Trabajos Recomendados
          </button>
        </div>
      </div>
      
      {applications.length > 0 ? (
        <div>
          {applications.map((application) => (
            <AppliedJobCard
              key={application.id}
              data={application}
              type="dashboard-employee"
            />
          ))}
        </div>
      ) : (
        <div className="applications__empty-state">
          <p>No tienes postulaciones aún. ¡Encuentra tu próximo trabajo!</p>
        </div>
      )}
      
      <div ref={recommendedJobsRef}>
        <RecommendedJobsDetail />
      </div>
    </div>
  );
};

export default Applications;
